import { useTranslation } from 'react-i18next';
import { Button, Icon, Stack, Text } from 'shell/components';

const InquireControls = ({ hasUnreadChat = false, onOpenChat }) => {
    const { t } = useTranslation('assignment');

    if (!onOpenChat) return null;

    return (
        <Stack sx={{ px: 3, py: 2 }} alignItems={'center'} direction={'row'} spacing={2}>
            <Button
                badge={hasUnreadChat}
                startIcon={<Icon kind={'messageSparkle'} />}
                variant={'secondary'}
                onClick={onOpenChat}
            >
                {t('common:controls.inquire', 'Inquire')}
            </Button>
            <Text color={'light'}>{t('chat.inquire-with-ai', 'Inquire with AI about feedback')}</Text>
        </Stack>
    );
};

export default InquireControls;
